
import { appCheck } from '../firebase';
import { getToken } from "firebase/app-check";

export async function fetchWithTrace(url, { method = 'GET', headers = {}, body, credentials = 'include' } = {}) {
  const clientId = crypto.randomUUID();
  const clientTs = new Date().toISOString();

  // W3C traceparent starter (new root trace)
  // format: version-traceId-parentId-flags
  const traceId = crypto.randomUUID().replace(/-/g, '').substring(0, 32);
  const parentIdTrace = crypto.randomUUID().replace(/-/g, '').substring(0, 16);
  const traceparent = `00-${traceId}-${parentIdTrace}-01`;

  let appCheckTokenHeader = {};
  if (appCheck) {
    try {
      const tokenResult = await getToken(appCheck, /* forceRefresh= */ false);
      const token = tokenResult.token;
      appCheckTokenHeader = { "X-Firebase-AppCheck": token };
    } catch (err) {
      console.error("App Check token error:", err);
      // Decide: Pass through without token? Or fail?
      // For now, pass through and let backend reject if strictly required.
    }
  }

  const isFormData = body instanceof FormData;
  // Auto-inject Auth token if present
  const token = localStorage.getItem('token');
  const authHeader = token ? { 'Authorization': `Bearer ${token}` } : {};

  const finalHeaders = {
    'X-Client-Request-Id': clientId,
    'X-Client-Timestamp': clientTs,
    'traceparent': traceparent,
    ...appCheckTokenHeader,
    ...authHeader,
    ...headers,
  };

  // Only set Content-Type if we're sending JSON (and not FormData)
  // For FormData, we MUST NOT set Content-Type so the browser sets the boundary
  if (body && !isFormData) {
    // If user provided a specific content type in headers, respect it? 
    // Usually we default to json.
    if (!finalHeaders['Content-Type']) {
      finalHeaders['Content-Type'] = 'application/json';
    }
  }

  // console.warn("DEBUG: Sending headers:", JSON.stringify(finalHeaders));

  const res = await fetch(url, {
    method,
    headers: finalHeaders,
    body: body ? (typeof body === 'string' || isFormData ? body : JSON.stringify(body)) : undefined,
    credentials,
  });

  // Grab backend correlation headers (make sure backend exposes them via CORS)
  const serverReqId = res.headers.get('X-Request-Id');
  const cloudTrace = res.headers.get('X-Cloud-Trace-Context') || res.headers.get('traceparent');

  // Example: attach IDs to thrown errors so UI can show them
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(`HTTP ${res.status} on ${url}: ${text.slice(0, 300)}`);
    err.status = res.status;
    err.requestIds = { clientId, serverReqId, cloudTrace };
    try {
      err.body = JSON.parse(text);
    } catch (e) {
      err.body = {};
    }

    // Global Error Dispatch for Rate Limits (429) & Validation (422)
    if (res.status === 429 || res.status === 422) {
      window.dispatchEvent(new CustomEvent('aleph-error', {
        detail: {
          status: res.status,
          message: err.body.error || err.body.message || 'An error occurred',
          details: err.body.details
        }
      }));
    }

    throw err;
  }

  // Return parsed JSON plus correlation
  const data = await res.json().catch(() => ({}));
  return { data, correlation: { clientId, serverReqId, cloudTrace, clientTs } };
}
